import React, { useEffect, useState } from "react";

const RoleAssignTables = ({
  dropdownOptions,
  //   activeRole,
  preSelectedOptions,
  onSelectionChange,
}) => {
  const initialStores =
    dropdownOptions?.map((obj) => {
      const id = Object.keys(obj)[0];
      return { id, name: obj[id] };
    }) || [];

  const [leftTable, setLeftTable] = useState(initialStores);
  const [rightTable, setRightTable] = useState([]);
  const [searchLeft, setSearchLeft] = useState("");
  const [searchRight, setSearchRight] = useState("");
  useEffect(() => {
    const allStores =
      dropdownOptions?.map((obj) => {
        const id = Object.keys(obj)[0];
        return { id, name: obj[id] };
      }) || [];

    const preSelectedStores =
      preSelectedOptions?.map((obj) => {
        const id = Object.keys(obj)[0];
        return { id, name: obj[id] };
      }) || [];

    const availableStores = allStores.filter(
      (store) => !preSelectedStores.some((selected) => selected.id === store.id)
    );

    setLeftTable(availableStores);
    setRightTable(preSelectedStores);
  }, [dropdownOptions, preSelectedOptions]);

  const filteredLeft = leftTable.filter(
    (item) =>
      item.name.toLowerCase().includes(searchLeft.toLowerCase()) ||
      item.id.toString().includes(searchLeft)
  );

  const filteredRight = rightTable.filter(
    (item) =>
      item.name.toLowerCase().includes(searchRight.toLowerCase()) ||
      item.id.toString().includes(searchRight)
  );

  const moveToRight = (id) => {
    const itemToMove = leftTable.find((item) => item.id === id);
    if (!itemToMove) return;

    const updatedRightTable = [...rightTable, itemToMove];
    setLeftTable(leftTable.filter((item) => item.id !== id));
    setRightTable(updatedRightTable);
    const formattedUpdatedRightTable = updatedRightTable.map(
      ({ id, name }) => ({ [id]: name })
    );
    onSelectionChange(formattedUpdatedRightTable);
  };

  const moveToLeft = (id) => {
    const itemToMove = rightTable.find((item) => item.id === id);
    if (!itemToMove) return;

    const updatedRightTable = rightTable.filter((item) => item.id !== id);
    setRightTable(updatedRightTable);
    setLeftTable([...leftTable, itemToMove]);
    onSelectionChange(
      updatedRightTable.map(({ id, name }) => ({ [id]: name }))
    );
  };

  const moveAllToRight = () => {
    const updatedRightTable = [...rightTable, ...filteredLeft];
    setRightTable(updatedRightTable);
    setLeftTable(leftTable.filter((item) => !filteredLeft.includes(item)));
    onSelectionChange(
      updatedRightTable.map(({ id, name }) => ({ [id]: name }))
    );
  };

  const moveAllToLeft = () => {
    setLeftTable([...leftTable, ...filteredRight]);
    const updatedRightTable = rightTable.filter(
      (item) => !filteredRight.includes(item)
    );
    setRightTable(updatedRightTable);
    onSelectionChange(
      updatedRightTable.map(({ id, name }) => ({ [id]: name }))
    );
  };

  return (
    <div className="flex gap-6 py-4">
      <div className="w-50 h-100 border p-4">
        <h6 className="font-bold">Available values</h6>
        <div className="input-group w-50 rounded mb-2">
          <input
            type="search"
            className="form-control rounded-start"
            placeholder="Search"
            value={searchLeft}
            onChange={(e) => setSearchLeft(e.target.value)}
          />
          <span
            className="input-group-text border-0 rounded-end"
            id="search-addon"
          >
            <img src="/images/search-icon.svg" alt="" />
          </span>
        </div>
        <div
          className="table-sec w-100"
          style={{
            height: "300px",
            overflow: "auto",
          }}
        >
          <table className="display w-100">
            <thead>
              <tr>
                <th>
                  <div className="th-title relative d-flex align-center">
                    Code
                  </div>
                </th>
                <th>
                  <div className="th-title relative d-flex align-center">
                    Name
                  </div>
                </th>
                <th className="d-flex justify-end align-items-center">
                  <button
                    className="btns btn-add"
                    onClick={() => moveAllToRight()}
                  >
                    <span className="material-symbols-outlined">add</span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredLeft.map((store) => (
                <tr key={store.id} className="border">
                  <td>{store.id}</td>
                  <td>{store.name}</td>
                  <td className="d-flex justify-end align-items-center">
                    <button
                      className="btns btn-add"
                      onClick={() => moveToRight(store.id)}
                    >
                      <span className="material-symbols-outlined">add</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Right Table */}
      <div className="w-50 h-100 border p-4">
        <h6 className="font-bold">Selected values</h6>
        <div className="input-group w-50 rounded mb-2">
          <input
            type="search"
            className="form-control rounded-start"
            placeholder="Search"
            value={searchRight}
            onChange={(e) => setSearchRight(e.target.value)}
          />
          <span
            className="input-group-text border-0 rounded-end"
            id="search-addon"
          >
            <img src="/images/search-icon.svg" alt="" />
          </span>
        </div>
        <div
          className="table-sec w-100"
          style={{
            height: "300px",
            overflow: "auto",
          }}
        >
          <table className="display w-100">
            <thead>
              <tr>
                <th>
                  <div className="th-title relative d-flex align-center">
                    Code
                  </div>
                </th>
                <th>
                  <div className="th-title relative d-flex align-center">
                    Name
                  </div>
                </th>
                <th className="d-flex justify-end align-items-center">
                  <div>
                    <button
                      className="btns btn-remove"
                      onClick={() => moveAllToLeft()}
                    >
                      <span className="material-symbols-outlined">remove</span>
                    </button>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredRight.map((store) => (
                <tr key={store.id} className="border">
                  <td>{store.id}</td>
                  <td>{store.name}</td>
                  <td className="d-flex justify-end align-items-center">
                    <div>
                      <button
                        className="btns btn-remove"
                        onClick={() => moveToLeft(store.id)}
                      >
                        <span className="material-symbols-outlined">
                          remove
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RoleAssignTables;
